import React from 'react';
import swal from 'sweetalert';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';

import BillingWindow from '../Wrappers/BillingWindow';
import { billing } from '../../services/api';
import PaymentMethodItem from './PaymentMethodItem';
import MethodAdded from './MethodAdded';
import * as billingActions from '../../redux/billing';
import { SmallTitle } from './Common';

interface Props {
  customer: Customer;
  billing: any;
  desktop: boolean;
  popup?: boolean;
}
interface State {
  email: string;
  updatingEmail: boolean;
  updateEmailDone: boolean;
}

class BillingPage extends React.Component<Props, State> {
  state: State = {
    email: this.props.customer.email,
    updatingEmail: false,
    updateEmailDone: false,
  };

  changeEmail(event: any) {
    this.setState({ email: event.target.value });
  }

  updateEmail() {
    this.setState({ updatingEmail: true });
    billing
      .updateEmail(this.state.email)
      .then(() => {
        this.setState({ updatingEmail: false, updateEmailDone: true });
      })
      .catch(() => {
        this.setState({ updatingEmail: false, updateEmailDone: true });
      });
  }

  openCardForm() {
    const email = this.state.email ? this.state.email : this.props.customer.email;
    if (!this.props.customer.id) this.props.billing.createCustomer(email, '/billing/card');
    else this.props.billing.changePage('/billing/card');
  }

  openAccountForm() {
    const email = this.state.email ? this.state.email : this.props.customer.email;
    if (!this.props.customer.id) this.props.billing.createCustomer(email, '/billing/account');
    else this.props.billing.changePage('/billing/account');
  }

  setDefault(id: string) {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure that you want to switch default payment method?',
      buttons: [true, true],
      icon: 'warning',
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.props.billing.changeDefaultSource(id);
      }
    });
  }

  removeSource(id: string) {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure that you want to remove this payment method?',
      buttons: [true, true],
      icon: 'warning',
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.props.billing
          .removeSource(id)
          .then(() => swal('Deleted!', 'Payment method removed!', 'success'));
      }
    });
  }

  render() {
    const basic = { color: '#555555', backgroundColor: '#eeeeee', letter: 'B' };
    const premium = { color: '#909798', backgroundColor: '#e8e2ce', letter: 'P' };
    const elite = { color: '#e8e2ce', backgroundColor: '#415859', letter: 'E' };

    const planStyle: any = {
      plan_DDxj5IO27PZonA: basic,
      plan_DDxs95IAhe370q: premium,
      plan_DDxusoAeeJ3OuF: elite,
      plan_DKJnSDrDpZnpQp: basic,
      plan_DKJoGwdJuZ8UnZ: premium,
      plan_DKJp437V8ODS5e: elite,
    };

    let planDetails: any = {};
    let planName: any = '';
    if (this.props.customer.subscriptions.total_count) {
      planName = this.props.customer.subscriptions.data[0].plan.nickname;
      planDetails = planStyle[this.props.customer.subscriptions.data[0].plan.id] || planDetails;
    }
    planName = this.props.customer.plan;

    if (this.props.customer.id === undefined) {
      this.props.billing.loadCustomer().then((data: any) => {
        return this.setState({ email: this.props.customer.email });
      });
      return (
        <div className="offer-loader" style={{ height: '500px', paddingTop: '240px' }}>
          Loading...
        </div>
      );
    }

    if (this.props.popup)
      return (
        <BillingWindow desktop={this.props.desktop} page="methods">
          <MethodAdded />
        </BillingWindow>
      );

    return (
      <BillingWindow desktop={this.props.desktop} page="methods">
        {planName ? (
          <div>
            <SmallTitle>PLAN</SmallTitle>
            <div className="paymentItem method-row" style={{ height: 'auto' }}>
              <div
                className="cardBorder"
                style={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  borderTop: 'solid 3px #dddddd',
                  borderBottom: 'solid 3px #dddddd',
                }}
              >
                {planDetails.letter && (
                  <div className="paymentIcon" style={{ backgroundColor: '#eeeeee' }}>
                    <div className="plan-circle" style={planDetails}>
                      {planDetails['letter']}
                    </div>
                  </div>
                )}
                <div
                  className="paymentItemName"
                  style={{
                    flexGrow: 1,
                    margin: 0,
                    padding: 0,
                    backgroundColor: '#eeeeee',
                    fontSize: '14px',
                  }}
                >
                  {planDetails.letter ? (
                    ''
                  ) : (
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  )}{' '}
                  Current plan: {planName}
                </div>
              </div>
            </div>
            <div className="col billing-small-blue">
              To update your plan, email{' '}
              <a
                href="mailto:partnerships@neoncoat.com"
                style={{ textDecoration: 'underline', color: '#909798' }}
              >
                partnerships@neoncoat.com
              </a>
            </div>
          </div>
        ) : null}
        <br />
        <SmallTitle>PAYMENT METHOD</SmallTitle>
        {this.props.customer.sources.data.map((item: PaymentSource) => (
          <PaymentMethodItem
            item={item}
            default={item.id === this.props.customer.default_source}
            key={item.id}
            setDefault={(id: string) => this.setDefault(id)}
            remove={() => this.removeSource(item.id)}
          />
        ))}

        <div
          className="paymentItem method-row"
          onClick={() => this.openCardForm()}
          style={{ marginBottom: '6px', marginTop: this.props.customer.sources.data.length > 0 ? '30px' : 'auto' }}
        >
          <div
            className="cardBorder"
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              borderTop: 'solid 2px #dddddd',
              borderBottom: 'solid 2px #dddddd',
            }}
          >
            <div className="paymentIcon" style={{ backgroundColor: '#fafafa' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                style={{ display: 'block', margin: 'auto', marginTop: '17px' }}
              >
                <g fill="none" fillRule="evenodd" stroke="#979797" strokeWidth="2">
                  <path d="M7.5 0v15M15 7.5H0" />
                </g>
              </svg>
            </div>
            <div className="col paymentItemName">Add Card</div>
          </div>
        </div>
        <div className="paymentItem method-row" onClick={() => this.openAccountForm()}>
          <div
            className="cardBorder"
            style={{ display: 'flex', flexWrap: 'nowrap', borderBottom: 'solid 2px #dddddd' }}
          >
            <div className="paymentIcon" style={{ backgroundColor: '#fafafa' }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                style={{ display: 'block', margin: 'auto', marginTop: '17px' }}
              >
                <g fill="none" fillRule="evenodd" stroke="#979797" strokeWidth="2">
                  <path d="M7.5 0v15M15 7.5H0" />
                </g>
              </svg>
            </div>
            <div className="col paymentItemName" style={{ flexGrow: 1 }}>
              Add Bank Account
            </div>
          </div>
        </div>
        <br />
        {this.props.customer.sources.data.length ? (
          <>
            <SmallTitle>BILLING EMAIL</SmallTitle>
            <div className="paymentItem method-row">
              <div
                className="cardBorder"
                style={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  borderTop: 'solid 3px #dddddd',
                  borderBottom: 'solid 3px #dddddd',
                }}
              >
                <div className="paymentIcon" style={{ backgroundColor: '#eeeeee' }}>
                  <img
                    src="/img/envelope.png"
                    alt="Add"
                    style={{ display: 'block', margin: 'auto', marginTop: '17px' }}
                  />
                </div>
                <div className="paymentItemName" style={{ flexGrow: 1, margin: 0, padding: 0 }}>
                  <input
                    type="email"
                    style={{
                      width: '100%',
                      margin: 0,
                      height: 'auto',
                      padding: 0,
                      paddingLeft: '15px',
                    }}
                    onChange={(e) => this.changeEmail(e)}
                    value={this.state.email}
                  />
                </div>
              </div>
            </div>
            <div className="billing-update-email" onClick={() => this.updateEmail()}>
              {this.state.updatingEmail ? 'UPDATING...' : 'UPDATE'}
            </div>
          </>
        ) : (
          <span></span>
        )}

        <div className="modal hide fade" id="myModal">
          <div className="modal-body">
            <MethodAdded desktop={true} />
          </div>
        </div>
      </BillingWindow>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    customer: state.billing.customer,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    billing: bindActionCreators(billingActions, dispatch),
    openCardForm: () => dispatch(push('/billing/card')),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingPage);
